<template>
  <div class="container" style="width:99%;margin-top:-25px;">
	<!--工具栏-->
	<div class="toolbar" style="float:left;padding:10px 12px;width:100%;box-sizing:border-box;background:linear-gradient(180deg,#fff 0%,#f8f9fb 100%);border-bottom:1px solid #e4e7ed;">
		<div class="filter-bar">
		<el-form :inline="true" :model="filters" :size="size" style="display:flex;align-items:center;flex-wrap:wrap;gap:6px;">
			<el-form-item style="margin-bottom:0;" class="filter-item">
				<el-select
				  class="sku-select"
				  v-model="filters.itemNumber"
				  filterable
				  remote
				  :remote-method="(query) => searchItems(query)"
				  :placeholder="$t('TblShippingLabelDetail.itemNumber')"
				  clearable
				  @clear="searchItems('')"
				  @visible-change="(visible) => { if (visible) searchItems('') }"
				  @change="findPage(null)"
				  style="width:200px">
				  <el-option
				    v-for="item in itemOptions"
				    :key="item.itemNumber"
				    :value="item.itemNumber"
				    :label="item.itemNumber + ' - ' + (item.description || '')">
				  </el-option>
				</el-select>
			</el-form-item>
		</el-form>
		</div>
	</div>
	<!--表格内容栏-->
	<kt-table permsEdit="sys:tblShippingLabel:edit" permsDelete="sys:tblShippingLabel:delete"
		:data="pageResult" :columns="columns" :buttonEdit="$t('action.splitCarton')" :displayButtonEdit="true" :displayButtonDelete="false" :showBatchDelete="false" :pageNum=this.pageRequest.pageNum :pageSize=this.pageRequest.pageSize
		@findPage="findPage" @handleEdit="handleEdit" @handleDelete="handleDelete">
	</kt-table>
	<!--新增编辑界面-->
	<el-dialog :title="operation?$t('common.add'):$t('common.edit')" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
		<el-form :model="dataForm" label-width="80px" :rules="dataFormRules" ref="dataForm" :size="size">
			<el-form-item :label="$t('TblShippingLabelDetail.id')" prop="id"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.id" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('TblShippingLabelDetail.whId')" prop="whId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.whId" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('TblShippingLabelDetail.cartonNumber')" prop="cartonNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.cartonNumber" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('TblShippingLabelDetail.itemNumber')" prop="itemNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.itemNumber" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('TblShippingLabelDetail.lotNumber')" prop="lotNumber"  v-if="dataForm.lotNumber">
				<el-input v-model="dataForm.lotNumber" auto-complete="off" disabled></el-input>
 			</el-form-item>
			<el-form-item :label="$t('TblShippingLabelDetail.qty')" prop="qty"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.qty" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TblShippingLabelDetail.cartonType')" prop="cartonType"  v-if="!dataForm.isPrimaryKey">
				<el-select ref="cartonType" v-model="dataForm.cartonType" style="width:100%">
					<el-option v-for="(cartonType,index) in this.cartonTypeData" :key="index" :value="cartonType.optionValue"
						:label="cartonType.optionDisplay"/>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('TblShippingLabelDetail.storedAttributeId')" prop="storedAttributeId"  v-if="false">
				<el-input v-model="dataForm.storedAttributeId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow1')" prop="genericAttrShow1"  v-if="dataForm.storedAttributeId">
				<el-input v-model="dataForm.genericAttrShow1" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow2')" prop="genericAttrShow2"  v-if="dataForm.storedAttributeId">
				<el-input v-model="dataForm.genericAttrShow2" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow3')" prop="genericAttrShow3"  v-if="dataForm.storedAttributeId">
				<el-input v-model="dataForm.genericAttrShow3" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow4')" prop="genericAttrShow4"  v-if="dataForm.storedAttributeId">
				<el-input v-model="dataForm.genericAttrShow4" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow5')" prop="genericAttrShow5"  v-if="dataForm.storedAttributeId">
				<el-input v-model="dataForm.genericAttrShow5" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow6')" prop="genericAttrShow6"  v-if="dataForm.storedAttributeId">
				<el-input v-model="dataForm.genericAttrShow6" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow7')" prop="genericAttrShow7"  v-if="dataForm.storedAttributeId">
				<el-input v-model="dataForm.genericAttrShow7" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow8')" prop="genericAttrShow8"  v-if="dataForm.storedAttributeId">
				<el-input v-model="dataForm.genericAttrShow8" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow9')" prop="genericAttrShow9"  v-if="dataForm.storedAttributeId">
				<el-input v-model="dataForm.genericAttrShow9" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow10')" prop="genericAttrShow10"  v-if="dataForm.storedAttributeId">
				<el-input v-model="dataForm.genericAttrShow10" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow11')" prop="genericAttrShow11"  v-if="dataForm.storedAttributeId">
				<el-input v-model="dataForm.genericAttrShow11" auto-complete="off" disabled></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
			<el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
		</div>
	</el-dialog>
  </div>
</template>

<script>
import KtTable from "@/views/Core/KtTable"
import KtButton from "@/views/Core/KtButton"
import { format } from "@/utils/datetime"
export default {
  name: 'TblShippingLabelDetail',
	components:{
			KtTable,
			KtButton
	},
	data() {
		return {
			size: 'small',
			cartonTypeData: Object,
			filters: {
        cartonNumber: '',
        whId: '',
        date:'',
        itemNumber:''
			},
			columns: [
				{prop:"id", label:"TblShippingLabelDetail.id", minWidth:100},
				{prop:"whId", label:"TblShippingLabelDetail.whId", minWidth:100},
				{prop:"cartonNumber", label:"TblShippingLabelDetail.cartonNumber", minWidth:100},
        		{prop:"cartonType", label:"TblShippingLabelDetail.cartonType", minWidth:100},
				{prop:"itemNumber", label:"TblShippingLabelDetail.itemNumber", minWidth:100},
				{prop:"description", label:"common.itemDescription", minWidth:120},
				{prop:"lotNumber", label:"TblShippingLabelDetail.lotNumber", minWidth:100},
				{prop:"qty", label:"TblShippingLabelDetail.qty", minWidth:100},
				{prop:"storedAttributeId", label:"TblShippingLabelDetail.storedAttributeId", minWidth:100},
				{prop:"genericAttrValue1", label:"attributes.genericAttrValue1", minWidth:100, display:false},
				{prop:"genericAttrValue2", label:"attributes.genericAttrValue2", minWidth:100, display:false},
				{prop:"genericAttrValue3", label:"attributes.genericAttrValue3", minWidth:100, display:false},
				{prop:"genericAttrValue4", label:"attributes.genericAttrValue4", minWidth:100, display:false},
				{prop:"genericAttrValue5", label:"attributes.genericAttrValue5", minWidth:100, display:false},
				{prop:"genericAttrValue6", label:"attributes.genericAttrValue6", minWidth:100, display:false},
				{prop:"genericAttrValue7", label:"attributes.genericAttrValue7", minWidth:100, display:false},
				{prop:"genericAttrValue8", label:"attributes.genericAttrValue8", minWidth:100, display:false},
				{prop:"genericAttrValue9", label:"attributes.genericAttrValue9", minWidth:100, display:false},
				{prop:"genericAttrValue10", label:"attributes.genericAttrValue10", minWidth:100, display:false},
				{prop:"genericAttrValue11", label:"attributes.genericAttrValue11", minWidth:100, display:false},
				{prop:"genericAttrShow1", label:"attributes.genericAttrShow1", minWidth:100},
				{prop:"genericAttrShow2", label:"attributes.genericAttrShow2", minWidth:100},
				{prop:"genericAttrShow3", label:"attributes.genericAttrShow3", minWidth:100},
				{prop:"genericAttrShow4", label:"attributes.genericAttrShow4", minWidth:100},
				{prop:"genericAttrShow5", label:"attributes.genericAttrShow5", minWidth:100},
				{prop:"genericAttrShow6", label:"attributes.genericAttrShow6", minWidth:100},
				{prop:"genericAttrShow7", label:"attributes.genericAttrShow7", minWidth:100},
				{prop:"genericAttrShow8", label:"attributes.genericAttrShow8", minWidth:100},
				{prop:"genericAttrShow9", label:"attributes.genericAttrShow9", minWidth:100},
				{prop:"genericAttrShow10", label:"attributes.genericAttrShow10", minWidth:100},
				{prop:"genericAttrShow11", label:"attributes.genericAttrShow11", minWidth:100},
			],
			pageRequest: { pageNum: 1, pageSize: 1000 },
			pageResult: {},
			itemOptions: [],

			operation: false, // true:新增, false:编辑
			editDialogVisible: false, // 新增编辑界面是否显示
			editLoading: false,
			dataFormRules: {
				qty: [
					{ required: true, message: this.$t('common.dataFormRules.quantityRequired'), trigger: 'blur' },
					{ pattern : /^[1-9]\d*$/,message: this.$t('common.dataFormRules.lineNumberPattern'), trigger: 'blur' }
				],
				cartonType: [
					{ required: true, message: this.$t('common.dataFormRules.required'), trigger: 'blur' }
				]
			},
			// 新增编辑界面数据
			dataForm: {
				id: null,
				whId: null,
				cartonNumber: null,
			itemNumber: null,
				lotNumber: null,
				qty: null,
				cartonType: null,
				storedAttributeId: null,
				genericAttrShow1: null,
				genericAttrShow2: null,
				genericAttrShow3: null,
				genericAttrShow4: null,
				genericAttrShow5: null,
				genericAttrShow6: null,
				genericAttrShow7: null,
				genericAttrShow8: null,
				genericAttrShow9: null,
				genericAttrShow10: null,
				genericAttrShow11: null,
}
}
	},
	methods: {
		getParentParams: function () {
		this.filters.cartonNumber=this.$route.query.cartonNumber
		this.filters.whId=this.$route.query.whId
		if (this.filters.whId) sessionStorage.setItem('tsld_whId', this.filters.whId)
		if (this.filters.cartonNumber) sessionStorage.setItem('tsld_cartonNumber', this.filters.cartonNumber)
		this.findPage(null)
		},
		//获取箱型类型下拉列表
		getCartonType: function (){
		let whId = this.dataForm.whId
		let objType = {whId:whId}
		this.$wmsApi.globalOption.getCartonType(objType)
			.then(res =>
			{
			//请求返回的数据
			this.cartonTypeData = res.data
			})
		},
		// 获取分页数据
		searchItems(query) {
			if (!this.filters.whId) return
			this.$wmsApi.globalOption.searchItems({ whId: this.filters.whId, keyword: query }).then(res => {
				this.itemOptions = res.data || []
			})
		},
		// 获取分页数据
		findPage: function (data) {
			if(data !== null && data.pageRequest) {
				this.pageRequest.pageNum = data.pageRequest.pageNum
				this.pageRequest.pageSize = data.pageRequest.pageSize
			}
			let whId=this.filters.whId
      let cartonNumber=this.filters.cartonNumber
      let itemNumber=this.filters.itemNumber
      this.pageRequest.columnFilters = {whId:{name:"whId",value:whId},cartonNumber: {name:'cartonNumber', value:cartonNumber},itemNumber: {name:'itemNumber', value:itemNumber}}
			this.$wmsApi.tblShippingLabelDetail.findPage(this.pageRequest).then((res) => {
				this.pageResult = res.data
			}).then(data!=null?data.callback:'')
		},
		// 批量删除
		handleDelete: function (data) {
			this.$wmsApi.tblShippingLabelDetail.batchDelete(data.params).then(data!=null?data.callback:'')
		},
		// 显示新增界面
		handleAdd: function () {
			this.editDialogVisible = true
			this.operation = true
			this.dataForm = {
				id: null,
				whId: null,
				cartonNumber: null,
				itemNumber: null,
				lotNumber: null,
				qty: null,
				createTime: null,
				remark: null,
				oriQty: null,
				pickStatus: null,
}
},
		// 显示编辑界面
		handleEdit: function (params) {
			this.editDialogVisible = true
			this.operation = false
			this.dataForm = Object.assign({}, params.row)
			this.dataForm.cartonType = null
			this.getCartonType()
		},
		// 分箱
		// 分箱（支持 ServiceResult 新格式和旧 ProcedureResult 格式）
		submitForm: function () {
			this.$refs.dataForm.validate((valid) => {
				if (valid) {
					this.$confirm(this.$t("common.message.confirmSubmission")+'', this.$t("common.message.prompt")+'', {confirmButtonText: this.$t("common.message.confirm")+'', cancelButtonText: this.$t("common.message.cancel")+''}).then(() => {
						this.editLoading = true
						let userName = sessionStorage.getItem('user')
						let localId = sessionStorage.getItem('localId')
						let id=this.dataForm.id
						let qty=this.dataForm.qty
						let cartonType=this.dataForm.cartonType
						let objReq = {id:id,qty:qty,cartonType:cartonType,userName:userName,localId:localId}
						this.$wmsApi.tblShippingLabelDetail.splitCarton(objReq).then((res) => {
							if(res.code == 200 && res.data && res.data.code === 'SUCCESS') {
								this.$message({message: this.$t("common.message.success") + (res.data.message ? ' ' + this.$t(res.data.message) : ''), type: 'success'})
				}
else if(res.code == 200 && res.data) {
								this.$message({message: this.$t("common.message.fail") + (res.data.message ? ' ' + this.$t(res.data.message) : ''), type: 'error'})
				}
else {
								this.$message({message: this.$t("common.message.fail") + ' ' + (res.msg || ''), type: 'error'})
				}
this.editLoading = false
							this.$refs['dataForm'].resetFields()
							this.editDialogVisible = false
							this.findPage(null)
						})
					})
	}
})
		},
		// 时间格式化
	dateFormat: function (row, column, cellValue, index){
	return format(row[column.property])
	}
	},
  activated: function () {
    if (this.$route.query.whId || this.$route.query.cartonNumber) {
      this.getParentParams()
    }
else {
      this.filters.whId = sessionStorage.getItem('tsld_whId')
      this.filters.cartonNumber = sessionStorage.getItem('tsld_cartonNumber')
      this.findPage(null)
    }
  },
	mounted() {
	}
}
</script>

<style scoped>
/* 工业软件风格 - 工具栏整体布局 */
.toolbar {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}

/* 筛选条件区 - 工业软件卡片风格 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 10px;
}

/* 筛选分组 */
.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
  margin-right: 6px;
}

/* 筛选分隔线 */
.filter-divider {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent 0%, #dcdfe6 50%, transparent 100%);
  margin: 0 4px;
}

/* 单个筛选项 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* 筛选标签 */
.filter-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
  min-width: 52px;
  text-align: right;
}

/* 操作按钮区 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
}

/* 响应式 - 小屏幕 */
@media screen and (max-width: 1200px) {
  .filter-bar {
    padding: 8px 10px;
  }
  .filter-label {
    display: none;
  }
  .filter-group {
    border-right: none;
    padding-right: 6px;
  }
}

/* 商品编码下拉框显示箭头图标 */
.sku-select.el-select.is-focused .el-select__caret {
  opacity: 1 !important;
  transform: rotateZ(180deg);
  color: #c0c4cc;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/Wms/TblShippingLabelDetail.vue